import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { registerLocaleData } from '@angular/common';
import localeEs from '@angular/common/locales/es';
import { ReactiveFormsModule } from '@angular/forms';
import { AppComponent } from './app.component';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { AppRoutingModule } from './app-routing.module';
import { CalendarModule, DateAdapter } from 'angular-calendar';
import { NgxSpinnerModule } from 'ngx-spinner';
import { VerificaComponent } from './verifica/verifica.component';
import { HeaderverComponent } from './verifica/headerver/headerver.component';
import { FooterComponent } from './verifica/footer/footer.component';
import { CookieService } from 'ngx-cookie-service';
import { LoadingComponent } from './verifica/loading/loading.component';

registerLocaleData(localeEs);

@NgModule({ declarations: [
        AppComponent,
        VerificaComponent,
        HeaderverComponent,
        FooterComponent,
        LoadingComponent,
    ],
    bootstrap: [AppComponent], imports: [
        // NgbModule,
        NgxSpinnerModule,
        BrowserModule,
        FormsModule,
        ReactiveFormsModule,
        AppRoutingModule,
        CalendarModule], providers: [
        CookieService,
        provideHttpClient(withInterceptorsFromDi())
    ] })

export class AppModule {

}